import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { NotificationsPage } from "@/features/notifications/NotificationsPage";

const search = z.object({
  tab: z.enum(["all", "unread", "read", "mentions", "assigned", "muted"]).optional(),
});

export const Route = createFileRoute("/_app/notifications/")({
  validateSearch: search,
  component: () => <NotificationsPage search={Route.useSearch()} />,
});
